(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name mapPairingGroups.controller:MapPairingGroupsCtrl
   *
   * @description
   *
   */
  angular
    .module('mapPairingGroups')
    .directive('focusOn',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOn,function(_focusVal) {
            $timeout(function() {
              _focusVal ? $element[0].focus() : $element[0].blur();
            });
          });
        }
      }
    })
    .controller('MapPairingGroupsCtrl', MapPairingGroupsCtrl);

  function MapPairingGroupsCtrl(CommonMasterData, ConfigDistributionService,mapPairingGroupsService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'MapPairingGroupsCtrl';
    vm.limitIndex = 30;
    vm.isBusyInRendering = false;

    editorMode : applicationConstants.EDITOR_STATUS.ADD;

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        fromTime : '00:00',
        toTime : '23:59',
        airport: null,
        pairingName: null
      },
	    identifierSubmition : {
		    identifiers : [],
		    patternIds:[]
	    },
      masterList: {
        airportList: [],
        pairings: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        fromTimeInvalid : false,
        toTimeInvalid : false,
        identifiers :[]
      },
      lastSearchDates:{
        fromDate:null,
        toDate:null,
        fromTime:null,
        toTime:null
      },
      mapPairingGroupsList: [],
      initialSearchDone: false,
      selectedRow:null,
      isElasticLoadingVisible:false,
      showBottomPanel:false,
      editorRow : null,
      selectAll : false
    };


    // to hide and show search panel
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // when change field in search
    vm.changeSearchField = function(searchParams, flag, params, viewValue) {
      if (flag === 'fromTime') {
        if (!isValidTime(searchParams.fromTime)) {
          vm.model.masterList.fromTimeInvalid = true;
        } else {
          vm.model.masterList.fromTimeInvalid = false;
          if (!isFromDateBeforeToDate()) {
            vm.model.searchCriteria.toTime = vm.model.searchCriteria.fromTime;
          }
        }
      } else if (flag === 'toTime') {
        if (!isValidTime(searchParams.toTime)) {
          vm.model.masterList.toTimeInvalid = true;
        } else {
          vm.model.masterList.toTimeInvalid = false;
          if (!isFromDateBeforeToDate()) {
            vm.model.searchCriteria.fromTime = vm.model.searchCriteria.toTime;
          }
        }
      } else if (flag === 'fromDate'
        && vm.model.searchCriteria.fromDate != null
        && vm.model.searchCriteria.fromDate != '') {
        if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
          vm.model.masterList.fromDateFormatInvalid = true;
        } else {
          vm.model.masterList.fromDateFormatInvalid = false;
            searchPairingNameList();
        }
      } else if (flag === 'toDate'
        && vm.model.searchCriteria.toDate != null
        && vm.model.searchCriteria.toDate != ''){
        if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
          vm.model.masterList.toDateFormatInvalid = true;
        } else {
          vm.model.masterList.toDateFormatInvalid = false;
           searchPairingNameList();
        }
      } else if(flag === 'matchingIndex'){
        setMatchingIndexForAirports(viewValue);
      } else if (flag === 'pairingName') {
        vm.model.searchCriteria.fromTime = '00:00';
        vm.model.searchCriteria.toTime = '23:59';
      }
      
    };

    function setMatchingIndexForAirports(viewValue){
      if(viewValue !== ' ' && viewValue!== null) {
        angular.forEach(vm.model.masterList.airportList, function(apt) {
          apt.matchingIndex = apt.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
        })
      }
    }

    // check from date and to date
    function isFromDateBeforeToDate() {
      return moment(
        vm.model.searchCriteria.fromDate + " "
        + vm.model.searchCriteria.fromTime,
        "DD/MM/YYYY HH:mm").isBefore(
        moment(vm.model.searchCriteria.toDate + " "
          + vm.model.searchCriteria.toTime,
          "DD/MM/YYYY HH:mm"));
    }

    // validate time
    function isValidTime(time) {
      var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
      return regex.test(time);
    }
    ;

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    //search pairing list by date range
    function searchPairingNameList() {
      var obj={};
      obj.fromDate = vm.model.searchCriteria.fromDate;
      obj.toDate= vm.model.searchCriteria.toDate;
      
      if(obj.fromDate == '' || obj.fromDate == null || obj.fromDate == 'undefined'){
		    vm.pairings = [];
		    return;
	    }
	  
	    if(obj.toDate == '' || obj.toDate == null || obj.toDate == 'undefined'){
		    vm.pairings = [];
		    return;
	    }

      vm.pairings = [];
      CommonMasterData.getPairingNames(obj, function(pairingList){
        angular.forEach(pairingList, function(name) {
          vm.model.masterList.pairings.push(' '+name+' ');
        });
      },function(){
        console.log('Pairing retrieval error');
      });

    }
    
    
    // submit search
    vm.submitSearch = function (params) {
      vm.model.mapPairingGroupsList=[];
      mapPairingGroupsService.searchMapPairingGroups(params,
        function (response) {
			    var defaultValues = {'fieldSelected':false};
			    angular.forEach(response.pairingDistributionGroupList, function(identifer) {
	          vm.model.mapPairingGroupsList.push(angular.merge(identifer, defaultValues));
	        });
          vm.model.searchPanelToggle = false;
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };
    
    vm.clickOnBottomPanelView = function() {
		vm.model.showBottomPanel = !vm.model.showBottomPanel;
	};

    vm.selectAll = function(){
      vm.model.selectAll = !vm.model.selectAll;
      if(!!vm.model.mapPairingGroupsList && vm.model.mapPairingGroupsList.length>0){
        for(var i=0; i<vm.model.mapPairingGroupsList.length;i++){
          vm.model.mapPairingGroupsList[i].isSelected = vm.model.selectAll;
          if (vm.model.selectAll){
            vm.model.identifierSubmition.patternIds.push(vm.model.mapPairingGroupsList[i].patternId);
          } else {
            vm.model.identifierSubmition.patternIds.pop(vm.model.mapPairingGroupsList[i].patternId);
          }

        }
      }
    };

    //when click on a row send button
    vm.doAction = function (event,index,selectedRowData, flag) {
      if (flag==='selectAll'){
        vm.selectAll();
      }else if(flag==='checkSelect'){

        if(selectedRowData.isSelected){
          vm.model.identifierSubmition.patternIds.push(selectedRowData.patternId);
        }else{
          vm.model.identifierSubmition.patternIds.pop(selectedRowData.patternId);
        }

      }
      vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
    };


	function searchIdentifiers() {
    ConfigDistributionService.searchIdentifiers(function(identifiers){
        var identifierArray = [];

        angular.forEach(identifiers, function(name) {
          identifierArray.push({'code':name,'name' :name });
        });

        vm.model.masterList.identifiers = identifierArray;
      },
      function(error){
        MessageService.error(error);
      }
    );
  }


	vm.submitIdetifiers = function() {
    if (vm.model.identifierSubmition === null || vm.model.identifierSubmition.patternIds.length === 0) {
      MessageService.success('At least one record should be selected.');
    } else if (vm.model.identifierSubmition.identifiers.length === 0) {
      MessageService.success('At least one distribution identifier should be selected.');
    } else {
      mapPairingGroupsService.updateIdentifiers(vm.model.identifierSubmition,
        function (response) {
          if(response.success){
            MessageService.success('Successfully updated the record(s)!');
            vm.submitSearch(vm.model.searchCriteria);
            vm.model.showBottomPanel = false;
            vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
            vm.model.identifierSubmition.patternIds = [];
            vm.model.identifierSubmition.identifiers = [];
            vm.model.masterList.identifiers = [];
            searchIdentifiers();

          }else{
            MessageService.error(response.errors[0]);
          }
        },
        function (error) {
          MessageService.error(error[0]);
        });
    }
	};


    (function () {
      // airportList
      CommonMasterData.getAirportList(function(airportList) {
        vm.model.masterList.airportList = airportList;
      }, function() {
        console.log('Airport List retrieval error');
      });


      searchIdentifiers();

    })();

  }
}());
